<!-- <div class="main-content">
  <div class="container-fluid">        
         <mat-accordion>
          <mat-expansion-panel *ngFor="let lastaudit of LastauditsBranches; let i = index" >
            <mat-expansion-panel-header class="right-aligned-header" >
              <mat-panel-title class="row">
                  <div class="col-4">
                    <span class="titles">{{lastaudit.modulename}}</span>
                  </div>
                  <div class="col-4">
                    <span class="titles">{{lastaudit.branchname}}</span>
                  </div>
                  <div class="col-4">
                    <span class="titles">{{lastaudit.date}}</span>
                  </div>

              </mat-panel-title>
              <mat-panel-description >
                 <span  [ngClass]="{
                  'red-box': lastaudit.totalscore < 50,
                  'orange-box': lastaudit.totalscore >= 50 && lastaudit.totalscore < 80,
                  'green-box': lastaudit.totalscore >= 80
                }">{{lastaudit.totalscore | number : '1.2-2'}} %</span>

              </mat-panel-description>

      

            </mat-expansion-panel-header>  
              <div class="row text-center">
                <div  class="col-6">
                  <div>
                    <ngx-gauge [type]="gaugeType"
                        [value]="lastaudit.totalscore"
                        [append]="gaugeAppendText"
                        [markers]="markerConfig"
                        [size]="300"
                        [thick]="20"
                        [foregroundColor]="'rgba(60, 146, 186,1)'"
                        >
                    </ngx-gauge>
                </div>
                </div>
                <div  class="col-6">
                  <label>
                    Audit Datailed Score
                  </label>
                  <div id="chartContainerName_{{i}}">
                    <canvas id="vmyChart_{{i}}"></canvas>
                  </div>
                </div>
        
              </div>
                
                <div class="row text-center mt-5">
           
                  <div class="col-3">
                    <label>
                      Standard Compilation
                     </label>
                    <div  id="chartContainerName_{{i}}"  >
                      <canvas id="sandtardcompilationdoughnutChart_{{i}}"></canvas>
                      </div> 
                    
                  </div>
                  <div class="col-3">
                    <label>
                      ACTION PLAN FOR TASKS
                      </label>
                    <div  id="chartContainerName_{{i}}" >
                      <canvas id="actionplandoughnutChart_{{i}}"></canvas>
                      </div>
                  </div>
                  <div class="col-6">
                    <label>
                      Score Performance Functional Score 
                    </label>
                    <div id="chartContainerName_{{i}}" style="height:100;" >
                      <canvas id="hmyChart_{{i}}"></canvas>
                      </div>
                  </div>
                </div>
      
          </mat-expansion-panel>
      </mat-accordion>
</div>

</div> -->

<div class="main-content">
  <div class="container-fluid">
    <mat-accordion>
      <mat-expansion-panel *ngFor="let lastaudit of LastauditsBranches; let i = index">
        <mat-expansion-panel-header class="right-aligned-header expHeight">
          <mat-panel-title class="row header-content">
            <div class="col-12 col-md-4">
              <span class="titles">{{ lastaudit.modulename }}</span>
            </div>
            <div class="col-12 col-md-4">
              <span class="titles">{{ lastaudit.branchname }}</span>
            </div>
            <div class="col-12 col-md-4">
              <span class="titles">{{ lastaudit.date | date:'yyyy-MM-dd' }}</span>
            </div>
          </mat-panel-title>
          <mat-panel-description>
            <span class="scorepercent" [ngClass]="{
              'red-box': lastaudit.totalscore < 50,
              'orange-box': lastaudit.totalscore >= 50 && lastaudit.totalscore < 80,
              'green-box': lastaudit.totalscore >= 80
            }">{{ lastaudit.totalscore | number : '1.2-2' }} %</span>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="row text-center">
          <div class="col-12 col-md-6">
            <div>
              <ngx-gauge [type]="gaugeType" [value]="lastaudit.totalscore" [append]="gaugeAppendText" [markers]="markerConfig" [size]="250" [thick]="20" [foregroundColor]="'rgba(60, 146, 186,1)'">
              </ngx-gauge>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <label>Audit Detailed Score</label>
            <div id="chartContainerName_{{ i }}" class="chart-container">
              <canvas id="vmyChart_{{ i }}"></canvas>
            </div>
          </div>
        </div>

        <div class="row text-center mt-5">
          <div class="col-12 col-md-3">
            <label>Standard Compilation</label>
            <div id="chartContainerName_{{ i }}">
              <canvas id="sandtardcompilationdoughnutChart_{{ i }}"></canvas>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <label>ACTION PLAN FOR TASKS</label>
            <div id="chartContainerName_{{ i }}">
              <canvas id="actionplandoughnutChart_{{ i }}"></canvas>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <label>Score Performance Functional Score</label>
            <div id="chartContainerName_{{ i }}" class="chart-container">
              <canvas id="hmyChart_{{ i }}"></canvas>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
